/* eslint-disable */
// import { TextField } from '@mui/material';
// import { classes } from '../../../Helpers';
import { HighlightOff } from '@mui/icons-material';
import { CheckPicker, SelectPicker, TreePicker } from 'rsuite';
import {
	addCommas,
	classes,
	convertWeightUnit,
	getHigherUnit,
	getUnitConvertedUnit,
	options,
} from '../../../Helpers';
import CustomInputSelector from '../../CustomInputSelector/CustomInputSelector';
import styles from './TableRow.module.scss';
import CoreSpecifications from './CoreSpecifications';
import { ProductListFilters } from '@/Components/Forms/Products';
import { Textarea } from '@/Components/ui/textarea';

const currencyTitles = [
	'Total Discount',
	'Sub total',
	'Total Tax',
	'Total Amount',
];

const renderQtyInfo = (skuStockInfo, index, product) => {
	return (
		<div className={styles?.quantitiesContainer}>

			{skuStockInfo?.map((infoEle) => {
				if (infoEle?.columnIndexToShowIn !== index) {
					return <></>;
				}
				const currentVariantValue = infoEle?.values?.[product?.selectedVariant?.id];
				return (
					<span
						className={styles?.quantities}
						style={{
							backgroundColor: infoEle?.bgColor,
							color: infoEle?.color,
						}}
					>
						<span className={styles?.title}>
							{infoEle?.name}
							:
						</span>
						<span className={styles?.value}>
							{currentVariantValue?.unit
								? `${currentVariantValue?.qty} ${currentVariantValue?.unit}`
								: convertWeightUnit(
									infoEle?.values?.[
									product?.selectedVariant?.id
									] ?? 0,
									product?.unit,
									undefined,
									true,
								)}
						</span>
					</span>
				);
			})}
		</div>
	);
};

function OEMSelector(props) {
	const { product, handleOemSelection } = props;
	return (
		<SelectPicker
			style={{
				width: '100%',
				fontSize: '11px',
				padding: '4px',
				margin: '4px 0',
				borderRadius: '4px',
			}}
			value={product?.oems?.find((oem) => oem?.isSelected)?.id || null}
			onChange={(selectedOemId) => {
				handleOemSelection([selectedOemId]);
			}}
			data={product?.oems?.map((oem) => ({
				label: oem.name,
				value: oem.id,
			}))}
			placeholder='Select OEM'
			searchable={false}
		/>
	);
}

function TableRow(props) {
	const {
		key,
		product,
		idx,
		quantity,
		handleQuantity = () => { },
		handleItemDescription = () => { },
		disabled,
		productWiseMappingData,
		handleSelection,
		productsList,
		servicesList = [],
		assetsList = [],
		handleRate,
		ratePerString = null,
		handleDiscount,
		addedItems = [],
		handleRemove = () => { },
		rowStyles,
		skuStockInfo,
		measurementType,
		handleTax = () => { },
		columns = [],
		handleOemSelection = () => { },
		handleSpecifications = () => { },
		isDeliveryChallan = false,
		isChangeable = true,
		rowError = {},
		handleChangeProductUnit = () => { },
		typeId,
		qtyRegex = null,
		customComponents = {},
		handleServiceAssetType = () => { },
		disableAll = false,
		handleInputBlur = () => { },
		handleItemComment = () => { },
		handleBatchId = () => { },
		handlePackSize = () => { },
		handlePacksRequired = () => { },
		packSizedOrder = false,
		canOrderInPacks = false,
		allItems = [], // Full state array to check for unique variant+pack combinations
	} = props;

	const tableRows = {
		'S.No': () => {
			return product?.unit ? (idx + 1) : '-';
		},
		'SERVICE': () => {
			return product?.productName ? (
				<>
					<div className={styles['added-item']}>
						{product?.productImageUrl && (
							<img src={product?.productImageUrl} alt='product' />
						)}
						<div className={styles['head-variants']}>
							<p>{product?.productName}</p>
							{product?.productName &&
								renderQtyInfo(skuStockInfo, 0, product)}
							<textarea
								className={styles['product-description']}
								value={product?.description ?? ''}
								onChange={(e) =>
									handleItemDescription(product?.id, e)
								}
								placeholder='comments'
							/>
						</div>
					</div>
				</>
			) : (
				<CustomInputSelector
					addedItems={typeId === 4 ? [] : addedItems}
					showImage
					handleSelection={handleSelection}
					inputLists={servicesList?.map((ele) => {
						return {
							...ele,
							name: ele?.name,
							imageUrl: ele?.image,
						};
					})}
					readOnly={disabled}
					skuStockInfo={skuStockInfo}
					addNewText='Add new Service'
					placeholder='Type or Click to select item'
				/>
			);
		},
		'ASSET TYPE': () => {
			return product?.assetTypeInfo ? (
				<>
					<div className={styles['added-item']}>
						{product?.assetTypeInfo?.productImageUrl && (
							<img src={product?.assetTypeInfo?.productImageUrl} alt='product' />
						)}
						<div className={styles['head-variants']}>
							<p>
								{product?.assetTypeInfo?.name}
							</p>
						</div>
					</div>
				</>
			) : (
				<CustomInputSelector
					addedItems={(typeId === 4 || typeId === 7) ? [] : addedItems}
					showImage
					handleSelection={(e) => handleServiceAssetType(product?.assetId ? product?.assetId : product?.id, e)}
					inputLists={assetsList?.map((ele) => {
						return {
							...ele,
							name: ele?.productName,
							imageUrl: ele?.productImageUrl,
						};
					})}
					readOnly={disabled}
					skuStockInfo={skuStockInfo}
					addNewText='Add new Asset Type'
					placeholder='Type or Click to select item'
				/>
			)
		},
		'ITEM DETAILS': () => {
			return product?.productName ? (
				<>
					<div className={styles['added-item']}>
						{product?.productImageUrl && (
							<img src={product?.productImageUrl} alt='product' />
						)}
						<div className={styles['head-variants']}>
							<p className='flex flex-col gap-2'>
								<span>
									{product?.productName}
									(
									{product?.selectedVariant?.displayName ?? product?.variantName}
									)
								</span>
								{product?.selectedVariant?.clientVariantId ? <span className='text-xs font-semibold text-gray-500'>{product?.selectedVariant?.clientVariantId}</span> : product?.clientVariantId ? <span className='text-xs font-semibold'>{product?.clientVariantId}</span> : null}
							</p>
							{product?.productName &&
								renderQtyInfo(skuStockInfo, 0, product)}
							{(typeId === 8) && (
								<Textarea
									placeholder='Comment'
									value={product?.comment}
									onChange={(e) =>
										handleItemComment(product?.id, e?.target?.value)
									}
									rows={1}
									className='min-h-0 h-7 py-1 resize-none text-xs'
								/>
							)}
						</div>
					</div>
					{(typeId === 4 || typeId === 7) && product?.coreSpecifications.length === 0 && (
						<span className='text-xs text-red-400'>{`There is no Core Specifications for this ${product?.productName}`}</span>
					)}
					{product?.salesConsumptionUnit && (
						<span className='text-xs text-red-400'>
							(
							variant based on consumption unit
							)
						</span>
					)}
					{(typeId === 4 || typeId === 7) && product?.oems && (
						<OEMSelector
							product={product}
							handleOemSelection={(selectedOemsIds) => {
								handleOemSelection(idx, selectedOemsIds);
							}}
						/>
					)}
				</>
			) : (
				<CustomInputSelector
					addedItems={(typeId === 4 || typeId === 7) ? [] : addedItems}
					showImage
					handleSelection={handleSelection}
					inputLists={productsList?.map((ele) => {
						return {
							...ele,
							name: ele?.productName,
							imageUrl: ele?.productImageUrl,
						};
					})}
					readOnly={disabled}
					skuStockInfo={skuStockInfo}
					addNewText='Add new Product'
					placeholder='Type or Click to select item'
					packSizedOrder={packSizedOrder || canOrderInPacks}
					unpackedOption={canOrderInPacks}
				/>
			);
		},
		UNIT: () => {
			if (!product?.higherUnit) {
				return ' ';
			}
			return product?.higherUnit;
		},
		'QTY-INFO': () => {
			return (
				product?.productName && renderQtyInfo(skuStockInfo, 2, product)
			);
		},
		'Batch Id': () => {
			return (
				<>
					<div className={classes(styles['editable-input'])}>
						{/* {customComponents?.QUANTITY?.(product)} */}
						<input
							className={classes(
								styles['custom-input'],
								rowError?.[product?.id]?.extraData?.batchId
									? styles.error
									: ''
							)}
							// type='number'
							readOnly={disabled}
							min={0}
							value={product?.extraData?.batchId}
							onChange={(e) => {
								const inputValue = e?.target?.value;
								handleBatchId(product?.id, inputValue);
							}}
							onBlur={() => handleInputBlur(product?.id)}
							onKeyDown={(e) => {
								if (e.key === 'Enter') {
									e.preventDefault();
									handleInputBlur(product?.id);
									e.target.blur();
								}
							}}
							placeholder='Batch Id'
							disbaled={!isChangeable}
						/>
					</div>
				</>
			);
		},
		'HSN Code': () => {
			const value = productsList.find((ele) => ele?.id === product?.productId)?.hsnCode;
			return (
				<p>{value || '-'}</p>
			);
		},
		SPECIFICATIONS: () => {
			return (
				<CoreSpecifications
					mode='rfq'
					showAllSpecs={false}
					className={styles['core-specs']}
					specifications={product?.coreSpecifications}
					onValueChange={(id, value) => {
						handleSpecifications(idx, id, value);
					}}
				/>
			);
		},
		'EXPECTED LEFT OVER': () => {
			return product?.expectedLeftOver ?? '-';
		},
		QUANTITY: () => {
			return (
				<>
					<div className={classes(styles['editable-input'])}>
						{customComponents?.QUANTITY?.(product)}
						<input
							className={classes(
								styles['custom-input'],
								rowError?.[product?.id]?.quantity
									? styles.error
									: ''
							)}
							type='number'
							readOnly={disabled}
							min={0}
							value={quantity}
							onChange={(e) => {
								const inputValue = e?.target?.value;
								let defaultRegex = /^(?:\d+(\.\d*)?|\.\d+)?$/;
								if (product?.higherUnit === 'count') {
									defaultRegex = /^\+?(0|[1-9]\d*)?$/;
								}
								const isPositiveDecimal = (
									qtyRegex ?? defaultRegex
								).test(inputValue);
								if (isPositiveDecimal) {
									handleQuantity(product?.id, inputValue, (typeId === 4 || typeId === 7 || typeId === 9 || canOrderInPacks) ? idx : null);
								}
							}}
							onBlur={() => handleInputBlur(product?.id)}
							onKeyDown={(e) => {
								if (e.key === 'Enter') {
									e.preventDefault();
									handleInputBlur(product?.id);
									e.target.blur();
								}
							}}
							placeholder='Quantity'
							disbaled={!isChangeable}
						/>
					</div>
					{product?.suggQty && <p className='text-xs text-blue-500 flex flex-row items-center text-nowrap'>Suggested Quantity: {product?.suggQty}</p>}
					{product?.higherUnit && product?.higherUnit !== 'count' && (
						<div className={styles.input_unit}>
							<p
								style={{
									fontSize: '.8rem',
								}}
							>
								Quantity in
							</p>
							<div className={styles.unit_options}>
								{product?.productInputUnit && (
									<div className='bg-yellow-300 rounded-md m-2 p-1 text-center w-full'>
										{product?.productInputUnit}
									</div>
								)}
								{/* {options?.[product?.productInputUnit]?.map(
									(ele) => {
										console.log(ele,"ele");
										console.log(product?.productInputUnit,"product?.productInputUnit");

										const isSelected =
											ele?.value ===
											product?.productInputUnit;
										return (
											<div
												onClick={() => {
													handleChangeProductUnit(
														product?.id,
														ele?.value
													);
												}}
												className={classes(
													styles.unit,
													isSelected
														? styles.selected
														: ''
												)}
											>
												{ele?.displayName}
											</div>
										);
									}
								)} */}
							</div>
						</div>
					)}
				</>
			);
		},
		RATE: () => {
			const findIfPriceFixed = productWiseMappingData?.find((ele) => {
				return ele?.productId === product?.productId;
			});
			return (
				<div className='min-w-20'>
					<div className={classes(styles['editable-input'])}>
						<input
							type='text'
							className={classes(
								styles['custom-input'],
								rowError?.[product?.id]?.rate
									? styles.error
									: ''
							)}
							readOnly={disabled}
							min={0}
							value={
								product?.selectedVariant?.price === null
									? product?.productCost
										? product?.productCost
										: ''
									: product?.selectedVariant?.price
							}
							onChange={(e) => {
								const val = e.target.value;
								if (val === '' || /^\d*\.?\d*$/.test(val)) {
									handleRate(
										product?.id,
										val === '' ? null : val,
										(typeId === 4 || typeId === 9 || typeId === 7 || canOrderInPacks)
											? idx
											: null
									);
								}
							}}
							placeholder='Rate'
							step='any'
							disabled={
								product?.disabledPrice ||
								(!(
									typeId === 1 ||
									typeId === 8 ||
									typeId === 4 ||
									typeId === 7 ||
									typeId === 9
								) &&
									(!findIfPriceFixed?.mappingTypeElementValue ||
										findIfPriceFixed?.mappingTypeElementValue ===
										'0'))
							}
						/>
					</div>
					{product?.unit && product?.unit !== 'count' && (
						<p
							style={{
								fontSize: '.8rem',
							}}
						>
							{ratePerString} Rate per{' '}
							{options?.[product?.unit]?.[0]?.displayName}
						</p>
					)}
					{product?.unit === 'count' && (
						<p
							style={{
								fontSize: '.8rem',
							}}
						>
							{ratePerString}
							{typeId === 9
								? 'Service per charges per item'
								: 'Rate per item'}
						</p>
					)}
				</div>
			);
		},
		'Discount%': () => {
			const isPriceFixed = productWiseMappingData?.find((ele) => {
				return ele?.productId === product?.productId;
			});
			if (
				(typeId !== 4 || typeId !== 7) &&
				(!isPriceFixed?.mappingTypeElementValue ||
					isPriceFixed?.mappingTypeElementValue === '0')
			) {
				return (
					<p className={styles['disabled-value']}>
						{product?.discountPercentage
							? Number(product?.discountPercentage)?.toFixed()
							: 0}
					</p>
				);
			}
			return (
				<>
					<div className={styles['editable-input']}>
						<input
							type='text'
							className={styles['custom-input']}
							readOnly={disabled}
							value={
								product?.discountPercentage
									? product?.discountPercentage
									: product?.discountPercentage === '' ? '' : 0
							}
							onChange={(e) => {
								const inputValue = e.target.value;
								const pattern =
									/^(100(\.0+)?|\d{0,2}(\.\d{0,2})?)$/;
								if (pattern.test(inputValue)) {
									handleDiscount(
										product?.id,
										e?.target.value,
										canOrderInPacks ? idx : null
									);
								}
							}}
							placeholder='Discount %'
						/>
					</div>
				</>
			);
		},
		'Total Discount': () => {
			return (
				<div className={styles['editable-input']}>
					₹
					{addCommas(product?.totalDiscount ?? 0) ?? 0}
				</div>
			);
		},
		'SAC CODE': () => `${product?.sacCode ? product?.sacCode : '-'}`,
		'TAX %': () => {
			return (
				[-1].includes(typeId) ? (
					<input
						type='number'
						className={styles['custom-input']}
						readOnly={disabled}
						value={product?.tax}
						onChange={(e) => handleTax(
							product?.id,
							e?.target.value,
							idx
						)}
						placeholder={product?.tax ? `${product?.tax}%` : 0}
					/>
				) : (
					<p className={styles['disabled-value']}>
						{product?.tax ? `${product?.tax}%` : 0}
					</p>
				)
			);
		},
		'Sub total': () => {
			return `₹${addCommas(product?.subTotal ?? 0) ?? 0}`;
		},
		'Total Tax': () => {
			return `₹${addCommas(product?.totalTax ?? 0) ?? 0}`;
		},
		'Total Amount': () => {
			if (isDeliveryChallan) {
				return `₹${Number(product?.subTotal ?? 0)?.toFixed(2) ?? 0}`;
			}
			return `₹${product?.selectedVariant
				? addCommas(product?.totalPriceIncTax ?? 0)
				: 0
				}`;
		},
		'PACK SIZE': () => {
			// Get pack sizes from the product's selectedVariant packSizeConfig
			const packSizes = product?.selectedVariant?.packSizeConfig || [];
			const selectedPackSize = product?.selectedPackSize;
			const availablePacks = selectedPackSize?.availableQty || 0;
			const currentVariantId = product?.selectedVariant?.id;

			// Get pack IDs that are already selected for this variant (excluding current row)
			const usedPackIdsForVariant = allItems
				?.filter((item, itemIdx) =>
					item?.selectedVariant?.id === currentVariantId &&
					item?.selectedPackSize?.id &&
					itemIdx !== idx
				)
				?.map((item) => item?.selectedPackSize?.id) || [];

			if (!product?.productName) {
				return '-';
			}

			// For canOrderInPacks mode
			if (canOrderInPacks) {
				// Build dropdown options with Unpacked as default
				const unpackedOption = { id: 'unpacked', quantity: 1, name: 'Unpacked' };
				const allPackOptions = [unpackedOption, ...packSizes];

				// If no packSizeConfig, show text only (Unpacked)
				if (packSizes.length === 0) {
					return (
						<div className='flex items-center justify-center'>
							<span className='text-sm font-medium bg-gray-100 px-3 py-1 rounded'>
								Unpacked (1)
							</span>
						</div>
					);
				}

				return (
					<div className='flex flex-col gap-1'>
						<SelectPicker
							style={{
								width: '100%',
								fontSize: '12px',
							}}
							value={selectedPackSize?.id || 'unpacked'}
							onChange={(selectedId) => {
								const selected = allPackOptions.find(p => p.id === selectedId);
								handlePackSize(product?.id, selected, idx);
							}}
							data={allPackOptions.map((pack) => ({
								label: pack.id === 'unpacked'
									? 'Unpacked (1)'
									: `Pack of ${pack.quantity}${pack.boxName ? ` (${pack.boxName})` : ''}`,
								value: pack.id,
								// Disable pack if already selected for this variant in another row
								disabled: usedPackIdsForVariant.includes(pack.id),
							}))}
							placeholder='Select Pack Size'
							searchable={false}
							cleanable={false}
							disabled={disabled}
							disabledItemValues={usedPackIdsForVariant}
						/>
					</div>
				);
			}

			// For packSizedOrder mode (existing logic)
			return (
				<div className='flex flex-col gap-1'>
					<SelectPicker
						style={{
							width: '100%',
							fontSize: '12px',
						}}
						value={selectedPackSize?.id || null}
						onChange={(selectedId) => {
							const selected = packSizes.find(p => p.id === selectedId);
							handlePackSize(product?.id, selected, idx);
						}}
						data={packSizes.map((pack) => ({
							label: `Pack of ${pack.quantity}${pack.boxName ? ` (${pack.boxName})` : ''}`,
							value: pack.id,
							// Disable pack if already selected for this variant in another row
							disabled: usedPackIdsForVariant.includes(pack.id),
						}))}
						placeholder='Select Pack Size'
						searchable={false}
						cleanable={false}
						disabled={disabled || packSizes.length === 0}
						disabledItemValues={usedPackIdsForVariant}
					/>
				</div>
			);
		},
		'PACKS REQUIRED': () => {
			if (!product?.productName) {
				return '-';
			}

			const variantId = product?.selectedVariant?.id;
			const packId = product?.selectedPackSize?.id;

			return (
				<div className={classes(styles['editable-input'])}>
					{customComponents?.QUANTITY?.(product)}
					<input
						className={classes(
							styles['custom-input'],
							rowError?.[product?.id]?.quantity
								? styles.error
								: ''
						)}
						type='number'
						readOnly={disabled}
						min={0}
						value={product?.quantity ?? ''}
						onChange={(e) => {
							const inputValue = e?.target?.value;
							let defaultRegex = /^(?:\d+(\.\d*)?|\.\d+)?$/;
							if (product?.higherUnit === 'count') {
								defaultRegex = /^\+?(0|[1-9]\d*)?$/;
							}
							const isPositiveDecimal = (
								qtyRegex ?? defaultRegex
							).test(inputValue);
							if (isPositiveDecimal) {
								// Pass variantId, packId, value, idx for unique variantId-packId mapping
								handlePacksRequired(variantId, packId, inputValue, idx);
							}
						}}
						onBlur={() => handleInputBlur(product?.id)}
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								e.preventDefault();
								handleInputBlur(product?.id);
								e.target.blur();
							}
						}}
						placeholder='Packs Required'
						disabled={!product?.selectedPackSize}
					/>
				</div>
			);
		},
		'NO. OF PCS TO BE PACKED': () => {
			if (!product?.productName) {
				return '-';
			}

			const packSize = product?.selectedPackSize?.quantity || 0;
			const packsRequired = product?.quantity || 0;
			const totalPcs = packSize * packsRequired;

			return (
				<div className='flex items-center justify-center'>
					<span className='text-sm font-medium bg-yellow-100 px-3 py-1 rounded'>
						{totalPcs}
					</span>
				</div>
			);
		},
		'FINAL QTY': () => {
			if (!product?.productName) {
				return '-';
			}

			const packSize = product?.selectedPackSize?.quantity || 1;
			const qty = product?.quantity || 0;
			const finalQty = packSize * qty;

			return (
				<div className='flex items-center justify-center'>
					<span className='text-sm font-medium bg-green-100 px-3 py-1 rounded'>
						{finalQty}
					</span>
				</div>
			);
		},
	};

	return (
		<tr
			key={product?.selectedVariant?.id}
			className={classes(styles['table-tr'], rowStyles)}
			aria-disabled={disableAll}
			style={{
				opacity: disableAll ? 0.5 : 1,
				pointerEvents: disableAll ? 'none' : 'auto',
			}}
		>
			{columns?.map((ele) => {
				const isCurrency = currencyTitles?.includes(ele?.title);
				return (
					<td
						align={isCurrency && 'right'}
						style={{
							width: ele?.width,
							opacity: disableAll && '50',
						}}
						aria-disabled={disableAll}
						onClick={() => {
							if (disableAll) {
								return;
							}
						}}
					>
						{tableRows?.[ele?.title]?.()}
					</td>
				);
			})}
			{/* <td>
			</td>
			<td>{product?.unit ?? '-'}</td>
			<td>
				{product?.productName &&
					renderQtyInfo(skuStockInfo, 2, product)}
			</td>
			<td>
				<div className={styles['editable-input']}>
					<input
						className={styles['custom-input']}
						type='number'
						value={product?.quantity ? product?.quantity : quantity}
						onChange={(e) => {
							handleQuantity(product?.id, e?.target.value);
						}}
						placeholder='Quantity'
					/>
				</div>
				{(product?.unit === 'gram' || product?.unit === 'oz') && (
					<p style={{
						fontSize: '.8rem',
					}}
					>
						Quantity in
						{' '}
						{product?.unit}
					</p>
				)}
			</td>
			<td>
				<div className={styles['editable-input']}>
					<input
						className={styles['custom-input']}
						value={
							product?.selectedVariant?.price
								? Number(
									product?.selectedVariant?.price
								)?.toFixed()
								: 0
						}
						onChange={(e) => {
							handleRate(product?.id, e?.target.value);
						}}
						placeholder='Rate'
					/>
				</div>
				{(product?.unit === 'gram' || product?.unit === 'oz') && (
					<p style={{
						fontSize: '.8rem',
					}}
					>
						Rate per
						{measurementType === 'US' ? 'lb' : 'kg'}
					</p>
				)}
			</td>
			<td>{product?.tax ? `${product?.tax}%` : 0}</td>
			<td>{Number(product?.subTotal ?? 0)?.toFixed(2) ?? 0}</td>
			<td>{Number(product?.totalTax ?? 0)?.toFixed(2) ?? 0}</td>
			<td>
				{product?.selectedVariant
					? Number(product?.totalPriceIncTax)?.toFixed(2)
					: 0}
			</td> */}
			{product?.id && !disabled && (
				<div
					onClick={() => {
						handleRemove(product, idx);
					}}
					className={styles['remove-container']}
				>
					<HighlightOff className={styles.icon} />
				</div>
			)}
		</tr>
	);
}

export default TableRow;
